// ConditionalNode.jsx
import React , { useState , useEffect } from 'react';
import { Handle, Position } from 'reactflow';
import TopHeaderPanel from '../TopHeaderPanel';
import { useReactFlow } from 'reactflow';
import Top_input from '../Top_input';
import Bottom_input from '../Bottom_input';
import CodeInput from './CodeInput';
import { Label } from 'reactstrap';

const ConditionalNode = ({ id , data }) => {
  const [selectedOption, setSelectedOption] = useState('1');
  
  const [selected_input_param, setselected_input_param] = useState(data.node_data.node_input[2].taken_input_from)
  const [selected_output_param, setselected_output_param] = useState(data.node_data.node_input[3].send_output_to)
  const [condition_type, setcondition_type] = useState(data.node_data.node_input[4]?.condition_type ? data.node_data.node_input[4]?.condition_type : "UI" )
  const [python_expression, setpython_expression] = useState(data.node_data.node_input[5]?.python_expression)

  
  const {setNodes} = useReactFlow()
  
     const [Input_Message, setInput_Message] = useState();
     const [operator, setoperator] = useState()
    const label = data?.label || 'Conditional Node';


    useEffect(() => {
      setInput_Message(data.node_data.node_input[0].condition_applied_on.input_data)
      setoperator(data.node_data.node_input[1].conditional_operator.input_data)

    }, [data])
    


  const handleOperand = (e) =>{
     setInput_Message(e.target.value)
     let newValue = e.target.value

      let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
    node_data_temp.node_input[0].condition_applied_on.input_data=newValue
    node_data_temp.node_output=node_data_temp.node_input



    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );

  }

  const handleOperator = (e) =>{
    setoperator(e.target.value)
    let newValue = e.target.value

    let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
    node_data_temp.node_input[1].conditional_operator.input_data=newValue
    node_data_temp.node_output=node_data_temp.node_input



    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
  }



  const onchange_condition_type=(e)=>{
      setcondition_type(e.target.value)
      let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[4]['condition_type']=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }
   


   
  const onchange_python_expression=(value)=>{
      setpython_expression(value)
      let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[5]['python_expression']=value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }

     const onchange_selected_input_param=(e)=>{
      setselected_input_param(e.target.value)
      let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[2].taken_input_from=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }

      const onchange_selected_output_param=(e)=>{
      setselected_output_param(e.target.value)


            let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[3].send_output_to=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }


  return (
    <>    
     <div className='node-style'>
        <div className='thpw'>{data.selectedNodeId === id && <TopHeaderPanel />}</div>
        
      <div className="node">
        <div className='node_head'>
        <span><i className='ri-braces-fill'></i></span>
          {label} <i className="mdi mdi-close" onClick={(e) => {
              e.stopPropagation();
              if (data?.onDelete) {
                data.onDelete(id);
              }
            }}></i>
            </div>
            
            <div className='node_body'>
                <Handle type="target" position={Position.Left}/>
                <Top_input selected_params={selected_input_param} onchange_selected_input_param={onchange_selected_input_param} />
                <Label className='cus-font'>Condition Type</Label>
                <select
                className='form-select'
                value={condition_type}
                onChange={onchange_condition_type}
              >
                <option value="UI">UI</option>
                <option value="python_expression">Python Expression</option>
              </select>
              {condition_type === 'UI' && (
                <div className='condition_input_textarea'>
                  <div className='condition  mt-3 mb-3'>
                    <span>If previous output</span>                    
                    <select  onChange={handleOperator} className="form-select" aria-label="Disabled select example" >
                        <option >{}</option>
                        <option selected={operator == '<='} value="<=">{"<="}</option>
                        <option selected={operator == '>='} value=">=">{">="}</option>
                        <option selected={operator == '=='} value="==">==</option>
                        <option selected={operator == '!='} value="!=">!=</option>
                        <option selected={operator == '<'} value="<">{"<"}</option>
                        <option selected={operator == '>'} value="<">{">"}</option>
                    </select>                    
                  </div>
                  <div className=''>
                      <textarea
                          onChange={handleOperand}
                          value={Input_Message}
                          placeholder="Operand"
                          rows={3} 
                          style={{ width: '100%' }} 
                          className="nodrag f-10 border" 
                          onMouseDown={(e) => e.stopPropagation()}
                          onClick={(e) => e.stopPropagation()}
                          onDoubleClick={(e) => e.stopPropagation()}
                        />
                  </div>
                  </div>
                  )}
                  
                
              
               {condition_type === 'python_expression' && (
                <div className='code_input'>
                  <CodeInput onchange_python_expression={onchange_python_expression} python_expression={python_expression} />
                </div>
               )}
               <Bottom_input selected_params={selected_output_param} onchange_selected_output_param={onchange_selected_output_param} />
              </div>
            
            {/* <Handle type="target" position={Position.Left} /> */}
            {/* Output Handle - Bottom Left */}
            <div>
              <span className='con_tf true_edge'>True</span>
              <Handle type="source" position={Position.Right} id='true' isConnectable={true}  style={{ top: '50%'}} />
            </div>
            {/* Output Handle - Bottom Right */}
            <div>
              <span className='con_tf false_edge'>False</span>
              <Handle type="source" position={Position.Right} id='false' isConnectable={true} style={{ top: '80%'}} />
            </div>
      </div>
      </div>
    </>
  );
};

export default ConditionalNode;
